import { render, staticRenderFns } from "./HotGamesView.vue?vue&type=template&id=0f39b503&scoped=true&"
import script from "./HotGamesView.vue?vue&type=script&lang=js&"
export * from "./HotGamesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f39b503",
  null
  
)

export default component.exports